var shop_url = "kushalsonline-com.myshopify.com";
var recordedChunks_video = [];
var formData = new FormData();
window.mmajaxcart = {
  AjaxcartOpen: function () {
    const body = $('body');
    const ajaxCart = $('.mm-ajaxcart');
    const ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');
    ajaxOverlay.addClass('has--active');

    clevertap.event.push("Cart Drawer Opened");
  },

  AjaxcartClose: function () {
      const body = $('body');
      const ajaxCart = $('.mm-ajaxcart');
      const ajaxOverlay = $('.mm-ajaxcart-overlay');

      body.removeClass('mm-no-scroll');
      ajaxCart.removeClass('has--opened');
      ajaxOverlay.removeClass('has--active');
      clevertap.event.push("Cart Drawer Closed");
    
  },

  AjaxcartRender: function () {
    $.get('/cart?view=ct-ajax', function (cart) {
        $('.mm-ajaxcart').html(cart);
      
        if(window.location.href.includes('/pages/product-bundling')) {
            updateCartElements(cart);
        }
        setTimeout(()=>{
          const apiPinCheckCalled = sessionStorage.getItem("eddPinCheckCart");
          const eddContainerCart = document.querySelector('.cart_ed_date_main');
          // If API was already called and no reset is required, return early
          if (!apiPinCheckCalled) {
              const locationStore = JSON.parse(localStorage.getItem('location_store'));
              fetchDeliveryDate(560004, parseInt(locationStore.postal));
          } else {
              const eddDateElement = document.querySelector('.edd-date-cart');
              const eddPDP = document.querySelector('.clickpost-edd__heading');
              const pinInputCheck = document.querySelector('.clickpost-edd__drop_pincode-input');
              const eddPDPElement = document.querySelector('.pre-edd-check');
              if (eddPDPElement) {
                  eddPDPElement.remove();
              }
  
              if (eddPDP && !pinInputCheck.value) {
                  const apiPinCheckContainer = document.createElement("div");
                  apiPinCheckContainer.className = "pre-edd-check";
                  apiPinCheckContainer.innerHTML = `<img src="//www.kushals.com/cdn/shop/files/Hurry_8b9a5a6f-ee84-4cf5-9751-19e5249d405e.png?v=17923254468046854946" alt="" width="20" height="auto" loading="lazy"> Order Now & Get it by <span class="edd-check-red">${apiPinCheckCalled}.</span>`;
                  eddPDP?.appendChild(apiPinCheckContainer);
              }
              if(eddDateElement) eddDateElement.innerHTML = apiPinCheckCalled;
              if(eddContainerCart) eddContainerCart.style.display = 'block';
          }
        }, 1000);


        const rawWishlistData = sessionStorage.getItem('wishlistData');
        const wishlistData = rawWishlistData ? JSON.parse(rawWishlistData) : [];

        if (Array.isArray(wishlistData) && wishlistData.length > 0) {
            try {
                let cartWsItems = document.querySelectorAll('.cart-wishlist-items');
                cartWsItems.forEach(item => item.style.display = 'block');
                displayWishlist(wishlistData); // Call function with parsed data
            } catch (error) {
                console.error("Error parsing wishlistData:", error);
            }
        } else {
            console.warn("No wishlist data found in session storage.");
        }

        // Get wishlist product IDs from localStorage and convert to a Set for fast lookup
        const wishlistDataPre = localStorage.getItem("local_wish_prod_data");

        let wishlistDataPrd;
        try {
            wishlistDataPrd = new Set(JSON.parse(wishlistDataPre) || []);
        } catch (error) {
            console.warn("Error parsing local_wish_prod_data, setting to empty array:", error);
            wishlistDataPrd = new Set();
        }

        const cartItems = [...document.querySelectorAll(".mm-ajaxcart-item")];

        cartItems.forEach((el) => {
            let variantId = el.getAttribute("data-variant_id");

            if (wishlistDataPrd.has(variantId)) {
                setTimeout(() => {
                    let matchedAdd = document.querySelectorAll(`.ct_wishlist_addcart_btn-${variantId}`);
                    let matchedAdded = document.querySelectorAll(`.prd-added-cart-${variantId}`);

                    matchedAdd.forEach((addBtn, index) => {
                        if (addBtn.getAttribute('data-prod-variant-id') === variantId) {
                            addBtn.style.display = "none";
                            if (matchedAdded[index]) {
                                matchedAdded[index].style.display = "flex";
                            }
                        }
                    });
                }, 1000);
            }
        });

        /**** Timer Setup ****/
        function startTimer(duration, display) {
            const startTime = Date.now();
            const endTime = startTime + duration * 1000;

            const interval = setInterval(function () {
                const currentTime = Date.now();
                const remainingTime = Math.max(0, Math.floor((endTime - currentTime) / 1000));

                const minutes = String(Math.floor(remainingTime / 60)).padStart(2, '0');
                const seconds = String(remainingTime % 60).padStart(2, '0');

                display.textContent = `${minutes}:${seconds}`;
                let cartHeaderTimer = document.querySelector('.cart_header_timer');
                if (cartHeaderTimer) cartHeaderTimer.style.display = 'block';
                localStorage.setItem('remainingTime', remainingTime);

                if (remainingTime <= 0) {
                    clearInterval(interval);
                    localStorage.setItem('popupHidden', 'true');
                    document.querySelector('.cart_header_timer').style.display = 'none';
                }
            }, 1000);
        }

        const display = document.querySelector('#time');
        const popupHidden = localStorage.getItem('popupHidden');
        const remainingTime = localStorage.getItem('remainingTime');

        /**** Custom Timer ****/
        let ct_timeLeft;
        let ct_timerInterval;

        function ct_updateTimer() {
            const ct_minutes = Math.floor(ct_timeLeft / 60);
            const ct_seconds = String(ct_timeLeft % 60).padStart(2, '0');
            ct_timeLeft--;

            if (ct_timeLeft < 0) {
                clearInterval(ct_timerInterval);
            } else {
                localStorage.setItem("ct_timeLeft", ct_timeLeft);
            }
        }

        function ct_startTimer() {
            ct_timerInterval = setInterval(ct_updateTimer, 1000);
        }

        function ct_startNewTimer() {
            ct_timeLeft = localStorage.getItem("ct_timeLeft") ? parseInt(localStorage.getItem("ct_timeLeft")) : 30;
            ct_startTimer();
        }

        const remain_time_left = localStorage.getItem("ct_timeLeft");
        if (remain_time_left > 0) {
            ct_startNewTimer();
        }

        // Fetch values from the DOM and localStorage
        const totalMainPrice = parseFloat($(cart).find(".theme-money-price").attr("data-price"));
        const countItem = $(".mm-emptycart-content").length;
        const storeData = localStorage.getItem('current_location');
        const ctLeftLocal = localStorage.getItem("ct_timeLeft");
        const cityArr = ['bengaluru'];

        // Check if the cart is empty
        if (countItem === 0) {
            if (popupHidden === 'true') {
                document.querySelector('.cart_header_timer').style.display = 'none';
            } else {
                if (remainingTime) {
                    startTimer(remainingTime, display);
                } else {
                    const oneMinute = 60 * 5;
                    startTimer(oneMinute, display);
                }
            }

            // Check if the storeData is not in cityArr
            if (cityArr.indexOf(storeData) === -1) {
                if (ctLeftLocal === null && totalMainPrice > 500) {
                    ct_startNewTimer();
                }
            }
        }

        /**** Sale Coupon Apply ****/
        if (countItem === 1) {
            $(".ct_cart_pro_main_perent").hide();
        } else {
            const mainCartPrice = parseFloat($(cart).find(".theme-money-price").attr("data-price"));
            let couponHTML = "";

            if (mainCartPrice > 499) {
                $(".ct_cart_pro_main_perent").show();
                $(".ct_cart_cong .ct_cong_perc").text("10%");
                $(".ct_progress_discount").addClass("ct_cong_active");
                $(".ct_cart_pro_main").hide();
                $(".ct_cart_pro_bottom").html(
                    `Hurray! You’ve Unlocked <b>Free Delivery</b> On Online Orders`
                );
            } else {
                $(".ct_cart_pro_main_perent").show();
                const priceToShow = 500 - mainCartPrice;
                const sliderShow = (160 * priceToShow) / 500;

                $(".ct_cart_value_cercal").css("stroke-dashoffset", sliderShow);
                $(".ct_cart_pro_main").show();
                $(".ct_cart_pro_bottom").html(
                    `<div class="ct_cart_pro_bottom_inner"> Shop for <span class="ct_add_more">₹ ${priceToShow}</span> more to unlock <span class="ct_perc_off">Free Delivery</span></div>`
                );
                localStorage.setItem('confet_item', 1);
            }
        }

        // Update header cart count
        $('.ct_42876301344924').click();
        const parser = new DOMParser();
        const cartHTML = parser.parseFromString(cart, 'text/html');
        const cartCount = cartHTML.querySelector('.mm-ajaxcart-header span').innerText.match(/\((\d+)\)/)?.[1];
        document.querySelectorAll('.header-cart__count').forEach(elem => {
            elem.innerText = cartCount;
        });

        mmajaxcart.Giftcard();
        closeLoader();
    });
  },

  AjaxcartChangeHandler: function(data) {
      $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: data,
          success: function(cart) {
                
              var cart_data = cart;
              var return_value = false;

              jQuery.each(cart_data.items_removed, function(i, c_val) {
                  var prod_id = c_val.product_id;
                  var get_ct_data = localStorage.getItem('ct_id');
                  var s_result = jQuery.parseJSON(get_ct_data);
                  $.each(s_result, function(i, val) {

                      if (prod_id == val.product_id) {
                          get_new_data_request = true;
                          var sku_val = "SKU "+c_val.sku;
                        //  var index = s_result.indexOf(val.c_id); //get index 
                          var index = s_result.findIndex(item => item.c_id === val.c_id);

                          s_result.splice(index, 1); //remove it
                        var attr_data_cart=JSON.stringify(s_result)
                          localStorage.setItem('ct_id', JSON.stringify(s_result)); //set again

                          if (typeof cart_data.note != "undefined") {
                              var data = cart_data.note;
                              var data_local = data;
                          } else {
                              var data_local = "";
                          }

                          var data_gift = data_local ? data_local : "";
                          var arr = data_gift.split('/');
                          var t="";
                            $.each(arr, function(i, val) {
                                var match_text="";
                                var innr = val.split('-');
                                $.each(innr, function(i1, val1) {
                                    match_text=val1
                                    return false;
                                })
                                if(match_text == sku_val)
                                {
                                  t= data_gift.replace(val, '');
                                  setTimeout(function() {

                                      $.post('/cart/update.js', {
                                              note: t,
                                              'attributes': {
                                                '_gift_wrap': attr_data_cart
                                              }
                                        
                                          })
                                          .done(function(t) {})
                                  }, 200);
                                  return false;
                                }
                                
                                  
                            })

                        
                        
                          // let data_gift = data_local ? JSON.parse(data_local) : [];
                          // $.each(data_gift, function(i, val) {
                          //     if (sku_val in val) {
                          //         var index = s_result.indexOf(sku_val);
                          //         data_gift.splice(index, 1); //remove it

                          //         var attribute = JSON.stringify(data_gift);

                          //         setTimeout(function() {

                          //             $.post('/cart/update.js', {
                          //                     note: attribute
                          //                 })
                          //                 .done(function(data) {})
                          //         }, 200);

                          //         return false;
                          //     }

                          // });


                          return_value = true;
                          return false;
                      }
                  });
                  if (return_value) {
                      return false;
                  }
              })

              mmajaxcart.AjaxcartRender();

              let CartCount = cart.item_count;
              if (CartCount <= 0) {
                  localStorage.removeItem("ct_id");
                  location.reload(true);
              }

              document.querySelectorAll('.header-cart__count').forEach((elem) => {
                  elem.innerText = cart.item_count;
              })
              $('.mm-cart-count').html(CartCount);
          }
      });

  },

  AjaxcartUpdateHandler: function(data) {
      let formData = {
          updates: data
      };

      fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
          })
          .then(response => {
              return response.json();
          }).then(cart => {
          
            jQuery.each(cart.items,function(key,value_main){
                $.each(data, function(key, value) {
                  if(value_main.key == key)
                    {
                      // console.log("Success");
                    }
                });
              
            })
              mmajaxcart.AjaxcartRender();

              let CartCount = cart.item_count;
              document.querySelectorAll('.header-cart__count').forEach((elem) => {
                  elem.innerText = cart.item_count;
              })
              $('.mm-cart-count').html(CartCount);
          })
          .catch((error) => {
              console.error('Error:', error);
          });

      // $.ajax({
      //   url: '/cart/update.js',
      //   dataType: 'json',
      //   cache: false,
      //   type: 'post',
      //   data: formData,
      //   success: function (cart) {
      //     mmajaxcart.AjaxcartRender();
      //     var CartCount = cart.item_count; 
      //     document.querySelector('.header-cart__count').innerText=cart.item_count;
      //     $('.mm-cart-count').html(CartCount);
      //   }
      // });

  },

  AjaxcartQuantityHandler: function() {
      function updateQuantity(elem) {
          var UpdatedQuantity = parseInt($(elem).val()),
              QuantityLine = parseInt($(elem).attr('data-line')),
              params = {
                  quantity: UpdatedQuantity,
                  line: QuantityLine
              };

          let parent = elem.closest("[data-custom-product]")
          let customProductQnty = UpdatedQuantity;
          if (elem.closest("[data-custom-product]")) {
              document.querySelectorAll("[data-custom-product]").forEach((ele) => {
                  if (ele != parent[0]) {
                      customProductQnty = customProductQnty + parseInt(ele.dataset.quantity);
                  }
              })
              params = {};
              let parentKey = $(elem).attr('data-key')
              let addOnKey = document.querySelector("[data-addOnproduct]")

              params[parentKey] = UpdatedQuantity
              if (addOnKey) {
                  addOnKey = addOnKey.dataset.key
                  params[addOnKey] = customProductQnty
              };
              mmajaxcart.AjaxcartUpdateHandler(params);
          } else {
            
              mmajaxcart.AjaxcartChangeHandler(params);
          }

      }

      $(document).on('change', '.quantity-input', function() {
          updateQuantity($(this).parent().find('.quantity-input'))
      })
      $(document).on('click', '.quantity-plus', function() {
          let q = $(this).parent().find('.quantity-input').val(),
              i = 1,
              p = parseInt(i),
              u = parseInt(q) + p;

          $(this).parent().find('.quantity-input').val(u)
          updateQuantity($(this).parent().find('.quantity-input'))
      })
      $(document).on('click', '.quantity-minus', function() {
          let q = $(this).parent().find('.quantity-input').val(),
              i = 1,
              p = parseInt(i),
              u = parseInt(q) - p;


          // $(this).parent().find('.quantity-input').val(u).trigger('change');
          $(this).parent().find('.quantity-input').val(u)
          updateQuantity($(this).parent().find('.quantity-input'))

      })
  },
  AjaxcartRemoveItem: function() {
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
        var RemoveLine = parseInt($(this).attr('data-line')),
            params = {
                quantity: 0,
                line: RemoveLine
            };

        let parent = this.closest("[data-custom-product]");

        if (parent && parent.hasAttribute('data-custom-product')) {
            let UpdatedQuantity = parseInt(parent.querySelector('input').value);
            let customProductQnty = 0;

            document.querySelectorAll("[data-custom-product]").forEach((ele) => {
                if (ele !== parent) {
                    customProductQnty += parseInt(ele.dataset.quantity);
                }
            });

            let parentKey = parent.dataset.key;
            let addOnKey = document.querySelector("[data-addOnproduct]");

            params[parentKey] = 0; // Update custom product quantity
            if (addOnKey) {
                params[addOnKey.dataset.key] = customProductQnty;
            }

            mmajaxcart.AjaxcartUpdateHandler(params);
        }
        mmajaxcart.AjaxcartChangeHandler(params);
    });
  },
  Ajaxupsell: function() {
      $(document).on('click', '.add-to-cart', function() {
          var variantId = $(this).attr('data-variantids')
          var data = {
              id: variantId,
              quantity: 1
          };
          fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json'
              },
              method: 'POST'
          }).then(function(response) {
              return response.json();
          }).then(function(json) {
          
              mmajaxcart.AjaxcartOpen();
              mmajaxcart.AjaxcartRender();
          }).catch(function(err) {
              /* uh oh, we have error. */
              console.error(err)
          });
      });
  },
  Giftcard: function() {
      get_gifting_configuration();
  }
}


$(document).ready(function() {
    

    $(document).on('click', '.ct_dev_checkout', function(e) {
        var c_id = localStorage.getItem('ct_id');
        if (c_id != null) {
            let formData = {
                'items': [{
                    'id': 42876301344924,
                    'quantity': 1,
                    'properties': {
                        '_Gift_wrap': c_id
                    }
                }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    window.location = "/checkout"

                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            //jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[Gift_wrap]=" + c_id);
        }
      else
        {
          window.location = "/checkout"
        }

    })
    $(document).on('click', '.mm-ajaxcart-open', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartOpen();
        
        mmajaxcart.Giftcard();
        mmajaxcart.Ajaxupsell();
    })
    $(document).on('click', '.mm-ajaxcart-close', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartClose();
    });
    $(document).on('click', '.mm-ajaxcart-overlay', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartClose();
    });

    //mmajaxcart.AjaxcartRender();
  //  mmajaxcart.Giftcard();
    mmajaxcart.AjaxcartRemoveItem();
    mmajaxcart.AjaxcartQuantityHandler();
    
    $(document).on('keyup', '#note', debounce(function() {
        var note = $(this).val();
        jQuery.post('/cart/update.js', "note=" + note);


    }, 500));


    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

  // Trust marker pass the event
 jQuery(document).on("click", ".Trust-mark-inner-cart .Trust-mark-box-cart", function() {
               
                var Tm_click={
                      "page":"Cart",
                     }
            clevertap.event.push("TM_click", Tm_click);
        });

       let customer_cartId = "";
    if (typeof __st.cid != "undefined") {
      customer_cartId = __st.cid;
    }
   
// Declare product_wish_data globally
let product_wish_data = null;
let currentCartItem = null;

$(document).on("click", ".cart_remove_btn", function () {

 
  currentCartItem = $(this).closest('.mm-ajaxcart-item');
  currentCartItem.addClass("active");
  // Ensure currentCartItem is valid
  if (!currentCartItem.length) {
    console.error("Cart item not found.");
    return;
  }

  // Get image and replace it in the popup
  const imgSrc = currentCartItem.find('.mm-ajaxcart-item-image img').attr('src');
  $('.pro_delete_detils_img img').attr('src', imgSrc);

  // Extract data attributes
  const product_id = currentCartItem.data("prod_id");
  const variant_id = currentCartItem.data("variant_id");
  const main_price = currentCartItem.attr("data_main_price");
  const sell_price = currentCartItem.attr("data_sell_price");
  const product_title = currentCartItem.data("prod-title");
  const product_type = currentCartItem.data("prod-type");
  const prod_sku= currentCartItem.data("sku");

  // Prepare product_wish_data
  product_wish_data = {
    groupId: product_id,
    name: product_title,
    price: sell_price,
    sellingPrice: main_price,
    image: imgSrc,
    sku:prod_sku,
    variantId: variant_id,
    customerEmail: "",
    accessToken: "",
    customerId: customer_cartId,
    registrationId: "",
    device: "WEB",
    version: "2.4",
    collectionName: product_type,
  };

  $('.cart_pro_delete').addClass('active');
  $(".pro_delete_bottom").attr("data-prod", JSON.stringify(product_wish_data));
});

$(document).on("click", ".pro_delete_remove", function (e) {
    e.preventDefault();

    if (!currentCartItem || currentCartItem.length === 0) {
        console.error("No cart item selected.");
        return;
    }

    let variantId = currentCartItem.data("variant_id");
    let variantRemove = document.querySelectorAll(".mm-ajaxcart-remove-item");

    showLoader();
    var prod_remove_sku = currentCartItem.data("sku");
    var wishlist_remove_item = {
        "sku": prod_remove_sku,
    };

    variantRemove.forEach((el) => {
        let variantIdCart = parseInt(el.getAttribute('data-variant_id'));

        if (variantIdCart === variantId) {
            clevertap.event.push("Wishlist Item Removed", wishlist_remove_item);
            $(el).trigger('click');  // Ensure only one correct item is removed
            $('.cart_pro_delete').removeClass('active');
        }
    });
});

$(document).on("click",".cart_pro_delete_close", function () {
  $('.cart_pro_delete').removeClass('active');
});

$(document).on("click", ".cart_pro_delete.active .pro_add_wishlist", async function (e) {
  e.preventDefault();
  showLoader();
  const product_wish_data_str = $(".pro_delete_bottom").attr("data-prod");

  // Ensure product_wish_data is valid
  if (!product_wish_data_str) {
    alert("Please select a product first.");
    return;
  }

  try {
    const prod_json = JSON.parse(product_wish_data_str);
    prod_json.registrationId = uniqueId;

    const added = await addProductToCollection(prod_json);
    
    
    if (added[1] !== "") {
      var p_sku=prod_json.sku;
       var move_to_wishlist={
                      "sku":p_sku
                     }
            clevertap.event.push("Move To Wishlist", move_to_wishlist);
        
      jQuery(".cart_pro_delete").removeClass("active");
       $(".cart_moved_wishlist").show();

      setTimeout(() => {
        $(".cart_moved_wishlist").hide();
        if (!currentCartItem || currentCartItem.length === 0) {
            console.error("No cart item selected.");
            return;
        }

        let variantId = currentCartItem.data("variant_id");
        let variantRemove = document.querySelectorAll(".mm-ajaxcart-remove-item");

        variantRemove.forEach((el) => {
            let variantIdCart = parseInt(el.getAttribute('data-variant_id'));

            if (variantIdCart === variantId) {
                $(el).trigger('click');  // Ensure only one correct item is removed
                $('.cart_pro_delete').removeClass('active');
            }
        });
      }, 2000); 
      sessionStorage.setItem("wishlistFetched", "false");
    }
  } catch (error) {
    console.error("Error processing wishlist action:", error);
  }
});

})

  async function addProductToCollection(data) {

  try {
    const response = await $.ajax({
      url: `${apiUrl}wishlist/collection-item`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(data),
    });

    return [response.success, data.groupId];
  } catch (error) {
    console.error("Error adding product to collection:", error);
    return [false, null];
  }
}

// This will apply the debounce effect on the keyup event
// And it only fires 500ms or half a second after the user stopped typing


// Wishlist modals
async function fetchWishlist() {
    let customerId = "";
    if (typeof __st.cid != "undefined") {
        customerId = __st.cid;
    }
    const url = `${apiUrl}customer/wishlist?registrationId=${uniqueId}&customerId=${customerId}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        // Log raw response
        const rawResponse = await response.text();

        let data;
        try {
            data = JSON.parse(rawResponse);

            // Store only the first 7 items
            if (Array.isArray(data)) {
                data = data.slice(0, 7);
            }
        } catch (error) {
            console.warn("Response is not valid JSON.");
            data = rawResponse;
        }

        sessionStorage.setItem("wishlistData", JSON.stringify(data));
        sessionStorage.setItem("wishlistFetched", "true");

    } catch (error) {
        console.error("Request Failed:", error);
    }
}

async function fetchDeliveryDate(pickupPinCode, dropPinCode, isPinCheck) {
  if(pickupPinCode  && dropPinCode)
  {
    
    const eddDateElement = document.querySelector('.edd-date-cart');
    const eddContainerCart = document.querySelector('.cart_ed_date_main');
  
    const url = 'https://middleware.technoboost.in/api/v1/callback/expected-delivery-date';
    const data = {
      pickupPinCode: pickupPinCode,
      dropPinCode: dropPinCode
    };
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
      if (result.deliveryBy) {
          if(eddContainerCart) eddContainerCart.style.display = 'block';
          if(eddDateElement) eddDateElement.innerHTML = result.deliveryBy; // Update innerHTML
          sessionStorage.setItem("eddPinCheckCart", result.deliveryBy);
          const eddPDP = document.querySelector('.clickpost-edd__heading');
          if (eddPDP && isPinCheck) {
              const apiPinCheckContainer = document.createElement("div");
              apiPinCheckContainer.className = "pre-edd-check";
              apiPinCheckContainer.innerHTML = `Order Now & Get it by <span class="edd-check-red">${result.deliveryBy}.</span>`;
              eddPDP?.appendChild(apiPinCheckContainer);
          }
      }
    } catch (error) {
      console.error('Error fetching delivery date:', error);
    }  
  }
}


// Run after DOM loads
document.addEventListener("DOMContentLoaded", function () {
  const apiCalled = sessionStorage.getItem("wishlistFetched");
  const wishlistData = JSON.parse(sessionStorage.getItem("wishlistData") || "[]");
  const isWishlistEmpty = !Array.isArray(wishlistData) || wishlistData.length === 0;

  // Call API if not called or wishlist data is empty
  if (apiCalled !== "true" || isWishlistEmpty) {
    fetchWishlist();
  }
});


async function displayWishlist(data) {
    const cartItemsContainer = document.querySelectorAll(".ws-cart-items");
    if (cartItemsContainer) {
      const processedData = await getProductData(data, true);
      cartItemsContainer.forEach((e) => {
        e.innerHTML = processedData;
      });
    }
}
